import { get, post } from 'api/client';
import { getExtendedTimeout } from 'utils/request';
import { getAiHubBaseURL } from 'app/config/aiHubEndpointMode';

export type TextTransformAction =
  | 'translate'
  | 'shorten'
  | 'expand'
  | 'fixGrammar'
  | 'rewrite'
  | 'makeEngaging'
  | 'addEmojis'
  | 'custom';

export const GenerationsApi = {
  transformText(data: {
    source: string;
    planType: string;
    action: TextTransformAction;
    targetLanguage?: string;
    customAction?: string;
  }): Promise<{ text: string }> {
    return post(`/generations/text/${data.action}`, data, {
      baseURL: getAiHubBaseURL(),
      timeout: getExtendedTimeout(3),
    });
  },
  getTransformTextOptions(): Promise<{
    options: {
      actions: TextTransformAction[];
      language: {
        value: string;
        label: string;
        bcp47: string;
      }[];
    };
  }> {
    return get('/generations/text/translate', {
      baseURL: getAiHubBaseURL(),
    });
  },
  generateHashtags(data: {
    source: string;
    planType: string;
  }): Promise<{ text: string }> {
    return post('/generations/text/generateHashtags', data, {
      baseURL: getAiHubBaseURL(),
      timeout: getExtendedTimeout(3),
    });
  },
};
